import _ from 'lodash';

import {
  WINE_CREATE, WINE_DELETE, WINE_LIST, WINE_READ, WINE_UPDATE
} from '@/store/actions/wine';
import {
  PRODUCER_LIST, PRODUCER_READ
} from '@/store/actions/producer';

import wineApi from '@/api/wine';
import { color2text } from '@/filters';
import { wineSort } from '@/sorters';

/* eslint-disable camelcase */


const state = {
  wines: [],

  wine: null,
  defaultItem: {
    wine_id: null,
    producer_id: null,
    name: null,
    target_temperature: null,
    color: null,
    reference: null,
    data: {
      label_url: null,
      description: {
        fr: null
      },
      appellation: null,
      vintage: null,
      grape: null,
      alcohol: null,
      allergen: null,
      tasting_advice: null,
      robe: null,
      barrel: null
    },

    _color_name: null,
    _producer_name: null
  }
};
state.wine = Object.assign({}, state.defaultItem);

const getters = {
};

const actions = {
  async [WINE_LIST] ({ commit, dispatch, getters }) {
    // Get producers
    await dispatch(PRODUCER_LIST);
    // Get wines
    let wines = await wineApi.getWines();

    // Complete data
    for (let w of wines) {
      let p = getters.producerById(w.producer_id);
      w._producer_name = p ? p.name : '';
      w._color_name = color2text(w.color);
    }

    // Sort
    wineSort(wines);

    // Commit mutation
    commit(WINE_LIST, wines);
  },

  async [WINE_CREATE] ({ commit }, { data, label }) {
    data = await wineApi.createWine(data);
    if (label) {
      data = Object.assign({}, data, await wineApi.updateLabel(data.wine_id, label));
    }

    commit(WINE_CREATE, data);
  },

  async [WINE_READ] ({ commit, dispatch, state }, id) {
    commit(WINE_READ, { wine_id: id });

    commit(WINE_READ, await wineApi.getWine(id));
    if (state.wine.producer_id) {
      await dispatch(PRODUCER_READ, state.wine.producer_id);
    }
  },

  async [WINE_UPDATE] ({ commit }, { data, label }) {
    data = Object.assign({}, data, await wineApi.updateWine(data));
    if (label) {
      data = Object.assign({}, data, await wineApi.updateLabel(data.wine_id, label));
    }
    commit(WINE_UPDATE, data);
  },

  async [WINE_DELETE] ({ commit }, id) {
    await wineApi.deleteWine(id);
    commit(WINE_DELETE, id);
  }
};

const mutations = {
  [WINE_LIST] (state, wines) {
    state.wines = wines;
  },

  [WINE_CREATE] (state, wine) {
    state.wines.push(wine);
  },

  [WINE_READ] (state, data) {
    state.wine = _.merge({}, state.defaultItem, data);
  },

  [WINE_UPDATE] (state, wine) {
    const idx = state.wines.findIndex(elt => elt.wine_id === wine.wine_id);
    state.wines.splice(idx, 1, wine);
  },

  [WINE_DELETE] (state, id) {
    const idx = state.wines.findIndex(elt => elt.wine_id === id);
    if (idx !== -1) {
      state.wines.splice(idx, 1);
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
